export default __webpack_public_path__ + "static/media/1138.642de53e.png";